import React from 'react';
import { Grid2, IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';

/**
 * Compact TextField with integrated translation button
 * Translation button appears as InputAdornment for a clean, compact design
 */
const TranslatableTextField = React.memo(
    ({
        value,
        onChange,
        onOpenTranslations,
        label,
        required = false,
        disabled = false,
        error = false,
        helperText = '',
        type = 'text',
        multiline = false,
        rows = 1,
        fullWidth = true,
        gridSize = { xs: 6 },
    }) => {
        const { t } = useTranslation();

        return (
            <Grid2 size={gridSize}>
                <TextField
                    fullWidth={fullWidth}
                    required={required}
                    disabled={disabled}
                    label={label}
                    value={value}
                    onChange={onChange}
                    error={error}
                    helperText={helperText}
                    type={type}
                    multiline={multiline}
                    rows={rows}
                    InputProps={
                        onOpenTranslations
                            ? {
                                  endAdornment: (
                                      <InputAdornment position="end">
                                          <Tooltip title={t('common.translations')}>
                                              <IconButton
                                                  onClick={onOpenTranslations}
                                                  disabled={disabled}
                                                  edge="end"
                                                  size="small"
                                              >
                                                  <LanguageIcon fontSize="small" />
                                              </IconButton>
                                          </Tooltip>
                                      </InputAdornment>
                                  ),
                              }
                            : undefined
                    }
                />
            </Grid2>
        );
    },
);

TranslatableTextField.displayName = 'TranslatableTextField';

export default TranslatableTextField;
